import React from "react";
import { Section } from "../Section";
import { CTAButton } from "../CTAButton";
export function Toolkit() {
  return <Section className="bg-cream" data-id="element-274" data-mp="1tgtl0w8kf1ah">
      <div className="grid gap-8 md:grid-cols-[0.9fr_1.1fr] md:gap-14" data-id="element-275" data-mp="1ti4r52phgl4r">
        <div data-id="element-276" data-mp="1ydk0bhcjpsuu">
          <p className="font-display text-sm font-semibold uppercase tracking-wider text-coral" data-id="element-277" data-mp="1ydtu7g0pok5t">
            Organized in one place
          </p>
          <h2 className="mt-2 text-balance font-display text-[30px] font-bold leading-[1.1] text-navy sm:text-4xl md:text-[44px]" data-id="element-278" data-mp="27gcubsd44iod">
            Your pediatric articulation planning toolkit
          </h2>
          <p className="mt-6 rounded-2xl bg-sun px-5 py-4 font-display text-xl font-semibold leading-snug text-navy" data-id="element-279" data-mp="2h534vsm7xeyz">
            Working with children's speech sound difficulties involves more than selecting a few words and repeating them.
          </p>
        </div>
        <div className="space-y-4 text-lg leading-relaxed text-ink/85" data-id="element-280" data-mp="2r1zfq4zlad6p">
          <p data-id="element-281" data-mp="2v5nlqj8kp0pu">
            You need to organize observations, identify relevant targets, prepare appropriate activities, document
            responses, and review what needs attention next.
          </p>
          <p data-id="element-282" data-mp="1vw5kj6zfafl8">
            When those resources are scattered across notebooks, downloaded files, and separate worksheets, planning
            can become unnecessarily time-consuming.
          </p>
          <p data-id="element-283" data-mp="1m13um8xbp9hl">
            I created the <strong className="text-navy" data-id="element-284" data-mp="2jn1hsjmne2zv">Pediatric Articulation Clinical Blueprint™</strong> to bring
            practical educational resources and planning tools together in one organized collection.
          </p>
          <p className="border-l-4 border-sky pl-4 font-semibold text-navy" data-id="element-285" data-mp="29wq2k0xik7do">
            Instead of starting every planning task from a blank page, you'll have structured materials to consult,
            adapt, and use as part of your professional workflow.
          </p>
        </div>
      </div>
      <div className="mt-12" data-id="element-286" data-mp="2xmao8rl1xiqn">
        <CTAButton label="Yes! I want the complete Blueprint" data-id="element-287" data-mp="2xm0wozkcz3iu" />
      </div>
    </Section>;
}